// hooks/useCategoryFilter.ts
import { useState } from "react";
import { SelectProduct, StylingStaff } from "../types/salon.types";

export const useCategoryFilter = (
  products: SelectProduct[] = [], // fallback empty array
  activeTab: "Staffs" | "Services",
  selectedStaff: StylingStaff | null
) => {
  const [filterProducts, setFilterProducts] = useState<SelectProduct[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);
  const [message, setMessage] = useState<string>("");

  // Handle selecting category
  const handleCategorySelect = (categoryId: string) => {
    setSelectedCategoryId(categoryId);

    // Safety check
    if (!Array.isArray(products) || products.length === 0) {
      setFilterProducts([]);
      setMessage("No products available. Please add products in Admin.");
      return;
    }

    // Filter products by category
    const productFilter = products.filter(
      (p) => p.categoryId === categoryId
    );

    // If active tab is staff and staff is selected
    if (activeTab === "Staffs" && selectedStaff) {
      const staffProducts = productFilter.filter(
        (p) =>
          Array.isArray(p.staffList) &&
          p.staffList.includes(selectedStaff.firstName)
      );

      setFilterProducts(staffProducts);

      if (staffProducts.length === 0) {
        setMessage(
          "No products assigned to this staff. Please add products in Admin."
        );
      } else {
        setMessage("");
      }

      return;
    }

    setFilterProducts(productFilter);

    // Empty category products message
    if (productFilter.length === 0) {
      setMessage(
        "No products found in this category. Please add products in Admin."
      );
    } else {
      setMessage("");
    }
  };

  // Reset category filter completely
  const resetCategoryFilter = () => {
    setFilterProducts([]);
    setSelectedCategoryId(null);
    setMessage("");
  };

  return {
    filterProducts,
    selectedCategoryId,
    handleCategorySelect,
    resetCategoryFilter,
    message,
  };
};